import React from 'react';
const Button = ({
  icon,
  title,
  handleClick,
  buttonStyle = '',
  textStyle = '',
  iconStyle,
  disabled = false
}) => {
  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      className={`flex p-2 rounded bg-secondary-400 items-center ${buttonStyle}`}
    >
      {icon && (
        <div className={`${iconStyle}`}>
          <img src={icon} alt='Button icon' />
        </div>
      )}
      <span className={`text-white select-none ${textStyle}`}>{title}</span>
    </button>
  );
};

export default Button;
